import React, { useState, useEffect } from "react";
import yaml from "js-yaml";
import CountrySelect from "./CountrySelect";
import StateSelect from "./StateSelect";
import CitySelect from "./CitySelect";
import { useNavigate } from "react-router-dom";
import ReCaptchaDemo from "../ReCaptchaDemo";
import BASE_URL from "../../config";

const VolunteerForm = ({ node, currentLanguage }) => {
  const [webformData] = useState({
    title: "Join as a Volunteer",
    description: "",
    elements: `
      personal_information:
        '#type': fieldset
        '#title': 'Personal Information'
        fullname:
          '#type': textfield
          '#title': FullName
          '#placeholder': 'Enter Your Name'
          '#required': true
          '#required_error': 'Enter your name field is required'
        dob:
          '#type': date
          '#title': 'Date of Birth'
          '#placeholder': 'Enter your DOB'
          '#required': true
          '#required_error': 'This field is required'
          '#format': d/m/y
          '#date_date_max': today
        gender:
          '#type': select
          '#title': Gender
          '#options':
            Male: Male
            Female: Female
            Other: Other
          '#required': true
          '#required_error': 'This field is required'
        nationality:
          '#type': textfield
          '#title': Nationality
          '#placeholder': 'Enter your Nationality'
          '#required': true
          '#required_error': 'This field is required'
      contact:
        '#type': fieldset
        '#title': 'Contact Information'
        address:
          '#type': textarea
          '#title': Address
          '#placeholder': 'Enter your Address'
          '#required': true
          '#required_error': 'This field is required'
        country:
          '#type': select
          '#title': Country
          '#options': country_names
          '#required': true
          '#required_error': 'This field is required'
        state:
          '#type': select
          '#title': State
          '#options': state_names
          '#required': true
          '#required_error': 'This field is required'
        city:
          '#type': select
          '#title': City
          '#options': province_names
          '#required': true
          '#required_error': 'This field is required'
        zipcode:
          '#type': number
          '#title': 'Zip Code '
          '#placeholder': 'Enter your zip code'
          '#required': true
          '#required_error': 'This field is required'
        mobile:
          '#type': tel
          '#title': Mobile
          '#placeholder': 'Enter your mobile number'
          '#required': true
          '#required_error': 'This field is required'
        mail:
          '#type': email
          '#title': Email
          '#placeholder': 'Enter your Email'
          '#required': true
          '#required_error': 'This field is required'
      education:
        '#type': fieldset
        '#title': Education
        degree:
          '#type': textfield
          '#title': Degree
          '#placeholder': 'Enter Your Degree'
          '#required': true
          '#required_error': 'This field is required'
        university:
          '#type': textfield
          '#title': University
          '#placeholder': 'Enter Your University'
          '#required': true
      workexperience:
        '#type': fieldset
        '#title': 'Work Experience (If Applicable)'
        numberofyears:
          '#type': number
          '#title': 'Number of years'
          '#placeholder': 'Enter Your number of years'
          '#required': true
          '#required_error': 'This field is required'
        industry:
          '#type': textfield
          '#title': Industry
          '#placeholder': 'Enter Your industry'
          '#required': true
          '#required_error': 'This field is required'
        profession:
          '#type': textfield
          '#title': Profession
          '#placeholder': 'Enter Your Profession'
          '#required': true
        companyname:
          '#type': textfield
          '#title': '  Company Name'
          '#placeholder': 'Enter Your Company Name'
          '#required': true
          '#required_error': 'This field is required'
      language:
        '#type': fieldset
        '#title': 'Language Proficiency'
        '#placeholder': 'Enter Your Language'
        languagesknown:
          '#type': textfield
          '#title': 'Languages Known'
          '#required': true
          '#required_error': 'This field is required'
      areasofinterest:
        '#type': fieldset
        '#title': 'Areas of Interest for Volunteering'
        '#placeholder': 'Enter Your Volunteer'
        program:
          '#type': select
          '#title': Program
          '#options':
            'Shiksha Plus': 'Shiksha Plus'
            Elementary: Elementry
          '#required': true
          '#required_error': 'This field is required'
        location:
          '#type': select
          '#title': Location
          '#options':
            Delhi: Delhi
            Noida: Noida
            Dadri: Dadri
          '#required': true
        durationofinvolvement:
          '#type': number
          '#title': 'Duration of Involvement'
          '#placeholder': 'Enter Your Duration of Involvement'
          '#required': true
          '#required_error': 'This field is required'
        whydoyouwanttojointhisprogram:
          '#type': textarea
          '#title': 'Why do you want to join this program?'
          '#required': true
          '#required_error': 'This field is required'
      actions:
        '#type': webform_actions
        '#title': 'Submit button(s)'
        '#submit__label': 'Submit'
    `,
  });

  // const { title, body, bannerImage, imageAbout, path } = node;
  const [formValues, setFormValues] = useState({});
  const [error, setError] = useState(null);
  const [formError, setFormError] = useState({});
  const [csrfToken, setCsrfToken] = useState("");
  const navigate = useNavigate();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCaptchaVerify = (token) => {
    setCaptchaToken(token); // Save token when CAPTCHA is verified
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/session/token?_format=json`
        );
        if (!response.ok) throw new Error("Failed to fetch CSRF token");
        const data = await response.json();
        setCsrfToken(data);
      } catch (err) {
        console.error("CSRF Token Error:", err);
      }
    };

    fetchCsrfToken();
  }, []);


  const getMaxDate = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18); // Set date to 18 years ago
    return today.toISOString().split("T")[0]; // Format as yyyy-mm-dd
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues({
  //     ...formValues,
  //     [name]: value,
  //   });
  // };


  const validateField = (name, value, type, required = false) => {
    const trimmedValue = value.trim();
    let error = "";

    // 🔹 Handle required field
    if (required && !trimmedValue) {
      return "This field is required.";
    }

    // 🔹 Skip validation if not required and empty
    if (!required && !trimmedValue) {
      return "";
    }

    // 🔹 Type-based validation
    if (type === "text") {
      if (trimmedValue.length < 2) {
        error = "Must be at least 2 characters.";
      } else if (!/^[A-Za-z\s.]+$/.test(trimmedValue)) {
        error = "Only letters, spaces, and periods are allowed!";
      }
    } else if (type === "tel") {
      if (!/^\d{10}$/.test(trimmedValue)) {
        error = "Phone number must be exactly 10 digits!";
      }
    } else if (type === "email") {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue)) {
        error = "Invalid email format!";
      }
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value, type, required } = e.target;
    const error = validateField(name, value, type, required);

    setFormValues((prev) => ({ ...prev, [name]: value }));
    setFormError((prev) => ({ ...prev, [name]: error }));
  };

  const handleBlur = (e) => {
    const { name, value, type, required } = e.target;
    const error = validateField(name, value, type, required);

    setFormError((prev) => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      alert("Please complete the CAPTCHA.");
      return;
    }
    // Fields that are type 'textfield' and should be validated for special characters
    const textfieldKeys = [
      "fullname",
      "nationality",
      "degree",
      "university",
      "industry",
      "profession",
      "companyname",
      "languagesknown"
    ];

    for (const [key, value] of Object.entries(formValues)) {
      if (typeof value === "string") {
        const trimmedValue = value.trim();
        // ✅ Mobile number validation
        if (key === "mobile") {
          const mobilePattern = /^[6-9]\d{9}$/;
          if (!mobilePattern.test(trimmedValue)) {
            alert("Please enter a valid 10-digit mobile number (digits only, starting with 6-9).");
            return;
          }
          continue;
        }
        // ✅ Email validation
        if (key === "mail") {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(trimmedValue)) {
            alert("Please enter a valid email address.");
            return;
          }
          continue; // Skip further textfield validation
        }
        // Skip validation for non-textfield fields
        if (!textfieldKeys.includes(key)) continue;

        // Check minimum length
        if (trimmedValue.length < 2) {
          alert(`Field "${key}" must be at least 2 characters.`);
          return;
        }

        // Validate allowed characters for textfields only
        const textOnlyPattern = /^[A-Za-z\s.]+$/;
        if (!textOnlyPattern.test(trimmedValue)) {
          alert(`Only letters, spaces, and periods are allowed in "${key}".`);
          return;
        }
      }
    }




    setError(null);

    try {
      const requestData = {
        webform_id: "join_as_a_volunteer",
        "g-recaptcha-response": captchaToken,
        ...formValues,
      };
      setIsSubmitting(true);
      // console.log("Request Data:", requestData);

      // Make sure to await inside the try block and use only one response variable
      const response = await fetch(
        `${BASE_URL}/webform_rest/submit?_format=json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Basic c2hpc3NoYV9hZG1pbjpTaGlrc2hhaGNsQDIwMjQ=",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text(); // Read the error as text
        console.error("Error Response:", errorText);
        throw new Error(
          `HTTP error! Status: ${response.status}, Response: ${errorText}`
        );
      }

      // const data = await response.json();
      // console.log("Submission Response:", data);

      // Show success message and reset form
      setShowSuccessMessage(true);
      setFormValues({});
      setCaptchaToken("");
      // Redirect to /volunteer page after a short delay
      setTimeout(() => {
        setShowSuccessMessage(false); // Hide the message before redirect
        navigate("/volunteer");
      }, 3000);
    } catch (err) {
      console.error("Submission Error:", err);
      setError(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderField = (key, config) => {
    switch (config["#type"]) {
      case "fieldset":
        return (
          <fieldset key={key} className="mb-6 w-full">
            <legend className="block text-gray-700 text-xl font-bold mb-4">
              {config["#title"]}
            </legend>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Object.entries(config).map(([innerKey, innerConfig]) =>
                renderField(innerKey, innerConfig)
              )}
            </div>
          </fieldset>
        );

      // Handle other field types here...
      case "textfield":
        return (
          <div key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="text"
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              onChange={handleInputChange}
              onBlur={handleBlur}
              value={formValues[key] || ""}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
            {formError[key] && <p className="text-red-500">{formError[key]}</p>}
          </div>
        );
      case "tel":
        return (
          <div key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="tel"
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              pattern={config["#type"] === "tel" ? "[0-9]{10}" : null}
              onChange={handleInputChange}
              onBlur={handleBlur}
              value={formValues[key] || ""}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
            {formError[key] && <p className="text-red-500">{formError[key]}</p>}
          </div>
        );
      case "email":
        return (
          <div key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="email"
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              onChange={handleInputChange}
              onBlur={handleBlur}
              value={formValues[key] || ""}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
            {formError[key] && <p className="text-red-500">{formError[key]}</p>}
          </div>
        );
      case "number":
        return (
          <div key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="number"
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              onChange={handleInputChange}
              value={formValues[key] || ""}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
          </div>
        );
      case "select":
        if (key === "country") {
          return (
            <CountrySelect
              key={key}
              name={key}
              required={config["#required"]}
              value={formValues[key] || ""}
              onChange={handleInputChange}
            />
          );
        } else if (key === "state") {
          return (
            <StateSelect
              key={key}
              country={formValues["country"]} // Pass the selected country to StateSelect
              value={formValues[key] || ""}
              onChange={handleInputChange}
            />
          );
        } else if (key === "city") {
          return (
            <CitySelect
              country={formValues["country"]}
              state={formValues["state"]}
              value={formValues[key] || ""}
              onChange={handleInputChange}
            />
          );
        }
        if (key === "gender") {
          return (
            <div key={key}>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Gender
                <span className="text-red-500 ml-1">*</span>
              </label>
              <select
                name="gender"
                value={formValues[key] || ""}
                onChange={handleInputChange}
                required={config["#required"]}
                className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
          );
        }
        if (key === "location") {
          return (
            <div key={key}>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Location
                <span className="text-red-500 ml-1">*</span>
              </label>
              <select
                name={key}
                value={formValues[key] || ""}
                onChange={handleInputChange}
                required={config["#required"]}
                className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
              >
                <option value="">Select Location</option>
                <option value="Delhi">Delhi</option>
                <option value="Noida">Noida</option>
                <option value="Dadri">Dadri</option>
              </select>
            </div>
          );
        }
        if (key === "program") {
          return (
            <div key={key}>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Program
                <span className="text-red-500 ml-1">*</span>
              </label>
              <select
                name={key}
                value={formValues[key] || ""}
                onChange={handleInputChange}
                required={config["#required"]}
                className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
              >
                <option value="">Select Program</option>
                <option value="Shiksha Plus">Shiksha Plus</option>
                <option value="Elementary">Elementary</option>
              </select>
            </div>
          );
        }
        return (
          <div key={key}  >
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
            </label>
            <select
              name={key}
              onChange={handleInputChange}
              value={formValues[key] || ""}
              placeholder={config["#placeholder"]}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            >
              {Object.entries(config["#options"]).map(
                ([optionKey, optionValue]) => (
                  <option key={optionKey} value={optionKey}>
                    {optionValue}
                  </option>
                )
              )}
            </select>
          </div>
        );
      case "textarea":
        return (
          <div key={key} className="col-span-full">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <textarea
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              rows="4" cols="50" maxlength="300"
              onChange={handleInputChange}
              value={formValues[key] || ""}
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
          </div>
        );
      case "date":
        return (
          <div key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {config["#title"]}
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="date"
              name={key}
              required={config["#required"]}
              placeholder={config["#placeholder"]}
              max={getMaxDate()} // Set max date to today - 18 years
              onChange={handleInputChange}
              value={
                formValues[key]
                  ? formValues[key].split("/").reverse().join("-")
                  : ""
              }
              className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-100 sm:text-sm sm:leading-6"
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="max-w-4xl mx-auto"
      >
        <p className="text-center mb-4">{webformData.description}</p>

        {Object.entries(yaml.load(webformData.elements)).map(([key, config]) =>
          renderField(key, config)
        )}

        <div className="text-center mt-6">
          <ReCaptchaDemo onValidate={handleCaptchaVerify} />
          <br />
          <button
            type="submit"
            className={`p-2 mt-3 px-2 rounded-lg bg-warm-orange text-white ${captchaToken && !isSubmitting
              ? "" : "opacity-50 cursor-not-allowed"
              }`}
            disabled={!captchaToken || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
        {error && (
          <p className="text-red-500 text-center mt-4">
            Error: {error.message}
          </p>
        )}
      </form>
      {/* Success Message Popup */}
      {showSuccessMessage && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-md text-center">
            <h3 className="text-lg font-bold mb-4">Submission Successful!</h3>
            <p>Your record has been submitted. We will get back to you soon.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VolunteerForm;
